/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import FastTrackFinanceLogo from "./images/fast-track-finance.png";
import Check from "./images/check.png";
import FastTrackStar from "./images/fast-track-star.svg";
import LazyImage from "../../shared/lazy-image";
const LoanCalculatorInfo = ({ stEligibleData, preApproved}) => {
    const {isStEligible = false} = stEligibleData || {};
    const showCard = !preApproved || isStEligible;
    const renderLoanApprovalText = () => {
        if (isStEligible) {
            return "Enjoy FastTrack benefits. You are our top customer.";
        } else if (!preApproved) {
            return "Enjoy FastTrack benefits with CARS24 finance";
        } else return "";
    };
    return (
        <div styleName={"styles.leftWrapper"}>
            <h3 styleName={"styles.featureHeading"}>Loan calculator</h3>
            <p styleName={"styles.subHeading"}>Calculate your loan repayments. If you find a<br />lower interest rate, we will match it as well as<br />contribute <strong>$300 towards your deposit.</strong></p>
            <a href="https://drive.google.com/file/d/1F0bWk5o1KoG8kyRZ120nhGLePuISAvQq/view"  target="_blank">T&C apply</a>
            {showCard ? <div styleName="styles.fastTrackWrapper">
                <div styleName="styles.fastTrackFeatures">
                    <LazyImage styleName={"styles.fastTrackFeaturesLogo"} src={FastTrackFinanceLogo} width="122px" height="34px" />
                    <div>
                        <ul>
                            <li><span><LazyImage styleName={"styles.checkImg"} src={Check} /></span>Instant lodgement</li>
                            <li><span><LazyImage styleName={"styles.checkImg"} src={Check} /></span>12x faster approvals</li>
                        </ul>
                    </div>
                </div>
                <div styleName="styles.fastTrackBoxFooter">
                    <p><img src={FastTrackStar} />{renderLoanApprovalText()}</p>
                </div>
            </div> : null}
        </div>
    );
};

LoanCalculatorInfo.propTypes = {
    stEligibleData: PropTypes.object,
    preApproved: PropTypes.bool
};

export default LoanCalculatorInfo;
